import * as React from 'react';
import { FC } from 'react';

import { Box, Select, Text, VStack } from '@rbilabs/universal-components';
import { format, parseISO } from 'date-fns';

import ActionButton, {
  ActionButtonSizes,
  ActionButtonVariants,
  ActionLink,
} from 'components/action-button';
import { List } from 'components/list';
import { t } from 'state/intl/translations';
import { LOCALES } from 'state/intl/types';
import { getLocale } from 'utils/intl/language';
import { routes } from 'utils/routing';

import { ArrowButton } from '../../../components/arrow-button';
import noop from '../../../utils/noop';
import { ContentWrap } from '../support-form-v2.styled';

import { HeadingStyled, RecentOrdersDescriptionText } from './styled';
import { ISupportV2OrdersListViewProps } from './types';
import { localeStringToDateFnsLocale } from './utils';

const dateFormatForLocale = (locale: string) => (locale === LOCALES.fr_ca ? 'd MMMM' : 'MMMM d');

export const SupportV2OrdersListView: FC<React.PropsWithChildren<
  ISupportV2OrdersListViewProps
>> = ({
  dropdownOptions,
  items,
  onYearAndMonthChange,
  selectedYearAndMonth,
  onSelectOrder = noop,
  onClickSignin = noop,
  isAuthenticated = false,
}) => {
  return (
    <ContentWrap marginX="4" flex="1">
      <Box marginX="20" marginBottom="4">
        <ActionLink
          size={ActionButtonSizes.SMALL}
          to={routes.support}
          variant={ActionButtonVariants.OUTLINE}
        >
          {t('backToTopics')}
        </ActionLink>
      </Box>
      <HeadingStyled testID="section-heading">{t('recentOrders')}</HeadingStyled>
      <RecentOrdersDescriptionText>{t('refundEligibilityInfo')}</RecentOrdersDescriptionText>
      {isAuthenticated ? (
        <Box flex="1">
          <Text>{t('filterByMonth')}</Text>
          <Select
            testID="year-and-month-filter"
            onValueChange={onYearAndMonthChange}
            selectedValue={selectedYearAndMonth}
          >
            {dropdownOptions.map(o => (
              <Select.Item key={`${o.value}+${o.label}`} value={o.value} label={o.label} />
            ))}
          </Select>

          <List marginBottom="0">
            {items.map(item => (
              <ArrowButton
                onPress={() => onSelectOrder(item)}
                key={item._id}
                testID="order-list-item-link"
              >
                <VStack>
                  <Text>
                    {format(parseISO(item.createdAt), dateFormatForLocale(getLocale()), {
                      locale: localeStringToDateFnsLocale(getLocale()),
                    })}
                  </Text>
                  <Text>{t('xItems', { xItems: item.cart.cartEntries?.length })}</Text>
                </VStack>
              </ArrowButton>
            ))}
          </List>
        </Box>
      ) : (
        <ActionButton onPress={onClickSignin} testID="sign-in-button">
          {t('signInToViewOrders')}
        </ActionButton>
      )}
    </ContentWrap>
  );
};
